import JoinAsosWorldButton from "../../components/JoinAsosWorldButton/JoinAsosWorldButton";
import DownloadAppButton from "../../components/DownloadAppButton/DownloadAppButton";

export const getButtonRenderer = ({
  shouldShowJoinLoyaltyButton,
  showDownloadApp,
  renderAddToBag,
  productIsInStock,
  variantIsInStock,
}) => {
  const shouldShowLoyaltyButton =
    shouldShowJoinLoyaltyButton &&
    productIsInStock &&
    variantIsInStock !== false;

  if (shouldShowLoyaltyButton) {
    return <JoinAsosWorldButton />;
  }

  if (showDownloadApp) {
    return <DownloadAppButton />;
  }

  return renderAddToBag();
};
